import { render, staticRenderFns } from "./APIApply.vue?vue&type=template&id=2c87cbba&scoped=true&"
import script from "./APIApply.vue?vue&type=script&lang=js&"
export * from "./APIApply.vue?vue&type=script&lang=js&"
import style0 from "./APIApply.vue?vue&type=style&index=0&id=2c87cbba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c87cbba",
  null
  
)

export default component.exports